import React, { useState } from 'react';
import { auth, db, storage } from '../../Components/LoginComp/firebase';
import { addDoc, serverTimestamp, collection } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './uploadresource.css'; // Custom CSS for styling

function UploadResource() {
  const [formData, setFormData] = useState({

    contributorName: '',
    contributorEmail: '',
    resourceType: '',
    title: '',
    author: '',
    description: '',
  });

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [notification, setNotification] = useState({ type: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === 'application/pdf' || selectedFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
    ) {
      setFile(selectedFile);
      setNotification({ type: '', message: '' });
    } else {
      setNotification({ type: 'error', message: 'Only PDF and DOCX files are allowed.' });
    }
  };

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: '', message: '' }), 5000); // Notification disappears after 5 seconds
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.resourceType || !file) {
      showNotification('error', 'Please fill in all required fields and upload a file.');
      return;
    }

    setUploading(true);
    try {
      const fileRef = ref(storage, `resources/${Date.now()}_${file.name}`);
      await uploadBytes(fileRef, file);
      const fileURL = await getDownloadURL(fileRef);

      const resourceData = {
        ...formData,
        contributorEmail: auth.currentUser?.email || 'Anonymous',
        dateOfUpload: serverTimestamp(),
        fileURL,
      };

      await addDoc(collection(db, 'uploadresource'), resourceData);

      showNotification('success', 'Resource uploaded successfully!');
      setFormData({
        contributorName: '',
        contributorEmail: '',
        resourceType: '',
        title: '',
        author: '',
        description: '',
      });
      setFile(null);
    } catch (error) {
      console.error('Error uploading resource:', error);
      showNotification('error', 'Failed to upload the resource. Please try again.');
    }
    setUploading(false);
  };

  return (
    <>
    <section className="hero">
      <div className="hero-image">
          <img src="/imgbook.png" alt="Books and Research" />
        </div>
        <div className="hero-content">
          <h1>Eye Care Digital Library</h1>
          <p>Your gateway to advanced research and resources in optometry and vision science.</p>
        </div>
    </section>

    <div className="upload-resource-container-user">
      <h1 className="upload-title-user">Upload a Resource</h1>
      {notification.message && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
      <form className="upload-form-user" onSubmit={handleSubmit}>
        <div className="form-group-user">
          <label>Contributor's Name:</label>
          <input
            type="text"
            name="contributorName"
            value={formData.contributorName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group-user">
          <label>Contributor's Email:</label>
          <input
            type="email"
            name="contributorEmail"
            value={formData.contributorEmail}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group-user">
          <label>Date of Upload:</label>
          <input
            type="text"
            value={new Date().toLocaleDateString()}
            readOnly
            className="non-editable-user"
          />
        </div>
        <div className="form-group-user">
          <label>Resource Type:</label>
          <select
            name="resourceType"
            value={formData.resourceType}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Resource Type</option>
            <option value="Journal Article">Journal Article</option>
            <option value="Book">Book</option>
            <option value="E-book">E-book</option>
            <option value="Thesis/Dissertation">Thesis/Dissertation</option>
            <option value="Conference Paper">Conference Paper</option>
            <option value="Report">Report</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="form-group-user">
          <label>Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group-user">
          <label>Author:</label>
          <input
            type="text"
            name="author"
            value={formData.author}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group-user">
          <label>Brief Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
          ></textarea>
        </div>
        <div className="form-group-user">
          <label>Upload File (PDF or DOCX):</label>
          <input type="file" onChange={handleFileChange} accept=".pdf,.docx" required />
        </div>
        <button type="submit" className="submit-btn" disabled={uploading}>
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </form>
    </div>
  </>

  );
}

export default UploadResource;
